import { DefaultComponentFactory } from "./default.js";
import { DefaultComponentDataLoaderFactory } from "./loaders.js";
const getFactory = () => {
  return new DefaultComponentFactory();
};
const getLoaderFactory = () => {
  return new DefaultComponentDataLoaderFactory();
};
export {
  DefaultComponentDataLoaderFactory,
  DefaultComponentFactory,
  getFactory,
  getLoaderFactory
};
//# sourceMappingURL=index.js.map
